import { takeEvery, put, call } from 'redux-saga/effects';
import { ticketService } from '../../services/ticketService';
import { FETCH_TICKETS } from './actionTypes';
import { fetchTicketsSuccess, fetchTicketsFail } from './actions';

function* fetchTickets(action) {
  try {
    const tickets = yield call(ticketService.getTickets, action.payload);
    yield put(fetchTicketsSuccess(tickets));
  } catch (error) {
    yield put(fetchTicketsFail(error));
  }
}

function* ticketsSaga() {
  yield takeEvery(FETCH_TICKETS, fetchTickets);
}

export default ticketsSaga;
